var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-md-4 elevation-1"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.subjectGroups,"footer-props":{
      'items-per-page-text': 'Bộ môn mỗi trang',
      'items-per-page-all-text': 'Tất cả'
    }},scopedSlots:_vm._u([{key:"footer.page-text",fn:function(items){return [_vm._v("\n      "+_vm._s(items.pageStart)+" - "+_vm._s(items.pageStop)+" trên tổng\n      "+_vm._s(items.itemsLength)+"\n    ")]}},{key:"item.actions",fn:function(ref){
    var item = ref.item;
return [(!(item.config && item.config.default))?_c('SubjectGroupListAction',{attrs:{"selected":item}}):_vm._e()]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }